import { createApi } from '@reduxjs/toolkit/query/react';
import { ReauthBaseQuery } from '@skynet/data-auth-api';
import { dexApiBaseQuery } from '@skynet/data-dex-api';

// Empty API to use as a base for code generation
// Uses the DEX Web API base query with automatic token refresh
export const baseApi = createApi({
  reducerPath: 'dexVaultsApi',
  baseQuery: ReauthBaseQuery(dexApiBaseQuery),
  endpoints: () => ({}),
});
